import { InjectionToken } from '@angular/core'

export const HEADER_API_KEY = new InjectionToken<{
  'Ocp-Apim-Subscription-Key': string
}>('HEADER_API_KEY')
